import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import {getRoute, pushRoute} from '~/src/utilities/helpers/router';
import {SitemapContext} from '~/src/components/context/SitemapContext';
import {SettingsContext} from '~/src/components/context/SettingsContext';

const Link = (props) => {
    const sitemap = useContext(SitemapContext);
    const settings = useContext(SettingsContext);

    return (
        <a
            href={props.href}
            className={props.className}
            target={props.target}
            title={props.title}
            onClick={(event) => {
                if (event.defaultPrevented) {
                    return;
                }

                const href = getRoute(sitemap.all, props.href) || '';
                const internalLink = href !== props.href && !settings.enableServerRequest;

                props.onClick && props.onClick();

                if (internalLink || props.target === '_blank') {
                    event.preventDefault();
                }

                if (internalLink) {
                    if (event.ctrlKey || event.metaKey) {
                        window.open(props.href);
                        return;
                    }
                    return pushRoute(sitemap.all, props.href);
                }

                if (props.target === '_blank') {
                    window.open(props.href);
                }
            }}
        >
            {props.children}
        </a>
    );
};

if (process.env.NODE_ENV === 'development') {
    Link.propTypes = {
        href: PropTypes.string,
        target: PropTypes.string,
        className: PropTypes.string,
        children: PropTypes.node.isRequired,
        title: PropTypes.string,
        onClick: PropTypes.func
    };
}

export default Link;
